import {useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import React from 'react';
import * as Styled from './InviteModalStyles';
import closeIcon from '../../../images/close-icon.svg';
import hands from '../../../images/hands-presenting-straight.png';
import {Col, Container, Row} from 'react-bootstrap';
import validator from 'validator';
import PromptModal from '../PromptModal/PromptModal';
import Api from '../../api/Api';
import HandsCheckmark from '../../../images/Hands-Checkmark.svg';

interface InviteModalProps{
  isOpen: boolean;
  onClose: Function;
}

export const InviteModal = ({ isOpen, onClose }:InviteModalProps) => {
  const [emails, setEmails] = useState('');
  const [error, setError] = useState('');
  const [showPrompt, setShowPrompt] = useState(false);
  const [inviteSuccess, setInviteSuccess] = useState(false);

  const changeEmails = (e:any) => {
    setEmails(e.target.value);
    setError('');
  }
  const submitEmails = () => {
    if (!emails.trim()) {
      return;
    }
    const emailsArr = emails.split(/,|\n/).map(em => em.trim());
    if (emailsArr.length === 1 && !validator.isEmail(emailsArr[0])) {
      setError('Please add a valid email! \n Please separate emails by comma');
      return;
    }
    const isValid = emailsArr.every(newEmail => validator.isEmail(newEmail));
    if (!isValid) {
      setError('Please add valid email addresses');
      return;
    }
    onInvite(emailsArr);
    setEmails('');
    setError('');
  }
  const onInvite = async (emails:string[]) => {
    onClose();
    try {
      await Api.inviteMembers(emails);
      setInviteSuccess(true)

    } catch (err) {
      setInviteSuccess(false);
    }
    setShowPrompt(true);
    const timeout = setTimeout(() => {
      setShowPrompt(false);
      clearTimeout(timeout)
    }, 2000);
  }
  const onClosePrompt = () => {
    setShowPrompt(false);
    setInviteSuccess(false);
  }

  return (
    <>
      <Modal
        show={isOpen}
        onHide={onClose}
        animation={false}
        centered
        size='lg'
        contentClassName='ModalContent'
        dialogClassName='ModalDialog'
      >
        <Styled.ModalBody>
          <Styled.ModalClose onClick={onClose} className='HeaderBtn'>
            <Styled.StyledImg src={closeIcon} alt='Close' />
          </Styled.ModalClose>
          <Styled.H3>
            Spread the magic 💫
          </Styled.H3>
          <Container>
            <Row>
              <Col sm={5}>
                <Styled.StyledImg className="rotate" src={hands} alt="holding-hands" />
              </Col>
              <Col xs={12} sm={7}>
                <Styled.H5>
                  Invite friends to search on Trova
                </Styled.H5>
                <Styled.Textarea
                  cols={30}
                  rows={5}
                  placeholder="Add email addresses"
                  value={emails}
                  onChange={changeEmails}
                />
                {error &&
                  <Styled.ErrorText>
                    {error}
                  </Styled.ErrorText>
                }
                <Styled.TextHelper>
                  Separate multiple emails with commas: name@example.com, name2@example.com, name3@example.com.
                </Styled.TextHelper>
                <Styled.Text>
                  We will send your friends an individual invitation to join Trova.
                </Styled.Text>
                <Styled.StyledModalBtn
                  className='FeedbackFooter'
                  variant='primary'
                  onClick={submitEmails}
                >
                  Invite
                </Styled.StyledModalBtn>
              </Col>
            </Row>
          </Container>
        </Styled.ModalBody>
      </Modal>
      <PromptModal
        open={showPrompt}
        message={inviteSuccess ? (
          <Styled.InviteParagraph>
            <img src={HandsCheckmark} alt="all good" />
            <p>
              We’ve got your request.
              Your friend(s) will receive our invitation shortly.
            </p>
          </Styled.InviteParagraph>
        ) : (
          <Styled.InviteParagraph>
            Something went wrong. Please try again later!
          </Styled.InviteParagraph>
        )}
        onClose={onClosePrompt}
      />
    </>
  )
}